import type { RouteRecordRaw } from 'vue-router'

const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile/password',
    name: 'ProfilePassword',
    component: () => import('@/views/profile/Password.vue'),
    meta: {
      requiresAuth: true,
      title: '修改密码',
    },
  },
]

export default profileRoutes
